(function() {
    'use strict';

    angular
        .module('app')
        .directive('ddTree', ddTree);

    ddTree.$inject = ['$window'];
    
    function ddTree ($window) {
        // Usage:
        //     <ddTree></ddTree>
        // Creates:
        // 
        var directive = {
            restrict: "E",
            replace: true,
            link: link,
            scope: {
                collection: '=',
                onClicked: '=',
                onExpanded: '=?'
            },
            template: "<div class='tree-list'><dd-node ng-repeat='member in collection track by member.uniqueId' member='member' on-expanded='itemExpanded' on-clicked='itemClicked'></dd-node></div>"
        };
        return directive;

        function link(scope, element, attrs) {
            scope.itemClicked = function (item, doubleClick) {
                if (scope.onClicked) {
                    scope.onClicked(item, doubleClick);
                }
            }
            scope.itemExpanded = function (item) {
                if (scope.onExpanded) {
                    return scope.onExpanded(item);
                }
            }
        }
    }

})();